export enum AssistantType {
  Auth = 'auth',
  ReceivePrize = 'receivePrize',
}
